import * as service from './service'
export default {
  namespace: 'newOrderCancelReason',
  state: {
    demoData: {}
  },
  effects: {
    * getOrderCancelReasons ({ payload }, { call, put }) {
      const res = yield call(service.getOrderCancelReasons, payload)
      return res.data.data
    },
    * abortOrder ({ payload }, { call, put }) {
      const res = yield call(service.abortOrder, payload)
      return res.data
    },
    * queryCourierChance ({ payload }, { call, put }) {
      const res = yield call(service.queryCourierChance, payload)
      return res.data
    },
    * punishRule ({ payload }, { call, put }) {
      const res = yield call(service.punishRule, payload)
      return res.data
    },
    * locationRule ({ payload }, { call, put }) {
      const res = yield call(service.locationRule, payload)
      return res.data
    },
    * beforeAbort ({ payload }, { call, put }) {
      const res = yield call(service.beforeAbort, payload)
      return res.data
    },
    * goodsCheck ({ payload, bizCodeHandler, bizCodes }, { call, put }) {
      const res = yield call(service.goodsCheck, payload, bizCodeHandler, bizCodes)
      return res.data
    },
    * douYinCheck ({ payload }, { call, put }) {
      const res = yield call(service.douYinCheck, payload)
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
